import { render, staticRenderFns } from "./UploadSkyKids.vue?vue&type=template&id=83fc3954&lang=pug&"
import script from "./UploadSkyKids.vue?vue&type=script&lang=js&"
export * from "./UploadSkyKids.vue?vue&type=script&lang=js&"
import style0 from "./UploadSkyKids.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports